import styled from '@emotion/styled'
import { Button } from '@mui/material'
import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { useModalEvents } from '../../../xstate/events'
import Modal from '../Modal/Modal'

const Container = styled.div``

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  text-align: center;
`

const StyledH1 = styled.h1`
  font-size: 1.125rem;
  font-weight: 450;
`

const CallbackModal: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { t } = useTranslation()
  const { searchCallbackAppointments, closeModal } = useModalEvents()

  const headerId = 'callback-modal-header-id'
  const descriptionId = 'callback-modal-description-id'
  const additionalInfoId = 'callback-modal-additional-info-id'

  const buttonRef = useRef<HTMLButtonElement>(null)

  useEffect(() => {
    if (buttonRef.current) {
      buttonRef.current.focus()
    }
  })

  return (
    <Modal open={true} onClose={closeModal} fullWidth>
      <Container>
        <ContentContainer>
          <StyledH1 id={headerId}>{t('component.callbackModal.title')}</StyledH1>
          <p id={descriptionId}>{t('component.callbackModal.description')}</p>
          <p id={additionalInfoId}>{t('component.callbackModal.additionalInfo')}</p>
          <Button
            size="large"
            onClick={searchCallbackAppointments}
            aria-describedby={`${headerId} ${descriptionId} ${additionalInfoId}`}
            ref={buttonRef}
          >
            {t('component.callbackModal.buttonText')}
          </Button>
        </ContentContainer>
      </Container>
    </Modal>
  )
}

export default CallbackModal
